import React, { Component }  from 'react';
import './Sidebar.css'
import SidebarComponent from "./SidebarComponent";

const DesktopSidebar = ({sideBarListItems}) => {


    return (
        <section className="desktop-sidebar-container">
            <SidebarComponent sideBarListItems={sideBarListItems}/>
        </section>

    )
}
export default DesktopSidebar;